module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/rank_no3-cbe040bfbf8bcef56a98db4554cce047.png";